import { useSelectedProducts } from '../catalogue/useCustomerCatalogueService';

export const useSelectedBundleProducts = () => {
  const selectedProducts = useSelectedProducts();

  const mainDeviceProducts = selectedProducts.filter(product => product.category.isMainDevice);
  const peripheralProducts = selectedProducts.filter(product => !product.category.isMainDevice);

  return {
    mainDeviceProducts,
    peripheralProducts
  };
};
